<div fxFlexFill fxLayout="column" fxLayoutGap="10px">

  <!-- Header Section Starts -->
  <span fxLayout="row" class="div-header">
    <span fxFlex fxLayoutAlign="center center" fxLayout="row">
      <span class="heading medium" ngClass.xs="heading-xs medium">Unable to {{data.message}} for</span>
    </span>
  </span>

  <mat-dialog-content>
    <!-- Button Section starts -->
    <div fxLayout="column" fxLayoutGap="20px" style="padding-bottom:20px">

      <div fxLayout="column" class="div-content" fxLayoutGap="10px">
        <span fxLayout="column"  *ngFor="let obj of data.payload">
          <span class="textHeading medium">{{obj.name}}</span>
          <span class="error regular">{{obj.message}}</span>
          <mat-divider></mat-divider>
        </span>
      </div>

      <span fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center center">
        <button fxFlexAlign="center" mat-flat-button color="primary" class="button-done" (click)="onDone()"
          ngClass.xs="button-done xs">{{'ok' | transloco}}</button>
      </span>
    </div>


  </mat-dialog-content>
</div>
